import React, { useCallback, useEffect, useState } from 'react';
import SelectSportOptions from '../../components/SelectSport/SelectSportOptions';
import AuthenticationLayout from '../../components/AuthenticationLayout/AuthenticationLayout';
import { useNavigate } from 'react-router-dom';
import { useSelector, connect } from 'react-redux';
import routeConstant from '../../lib/constants/routeConstant';
import { getCurrentSeasons } from '../../redux/slices/seasonSlice';
import { filterString } from '../../lib/constants/globalConstant';
import CommonLoader from '../../components/shared/Loaders/CommonLoader/CommonLoader';

import middleLogo from '../../assets/svgs/ucla_logo.svg';

/*  Options object to determine the visibility and properties of the navigation button in the authentication layout. */
const options = {
  showButton: false,
  navUrl: "",
  buttonName: "",
  subHeading: "SELECT YOUR SPORT",
  isCentered: false,
  showMiddleImage: true,
  middleImage: middleLogo
}

/* Render the AuthenticationLayout component as a wrapper around the CreatePasswordForm. Pass the options object 
to control the layout's property */
const SelectSportPage = ({ getCurrentSeasons }) => {
  const navigate = useNavigate();
  const { seasons, currentSeason, error, fetchedSeasons, isLoading } = useSelector(state => state.seasons)
  const { user } = useSelector(state => state.user)

  const [loading, setLoading] = useState(true)

  const callApi = useCallback(async () => {
    await getCurrentSeasons(); // get current Seasons Detail
    setLoading(false);
  }, [getCurrentSeasons])

  useEffect(() => {
    // check if there is only one season
    if (seasons.length === 1 && fetchedSeasons) {
      navigate(`${routeConstant.SPORT_PAGE}/${currentSeason?._id}`, { replace: true })
    }
  }, [seasons, fetchedSeasons]);

  useEffect(() => {
    // if not fetched
    if (!fetchedSeasons) {
      callApi()
    } else {
      setLoading(false)
    }
  }, [callApi])

  if (isLoading || loading) {
    return <CommonLoader />
  }

  return (
    <AuthenticationLayout options={{
      ...options,
      heading: seasons?.length === 0 || !seasons ? error?.toString() : "WELCOME " + filterString(user?.userDetails?.userNickName, 30),
      subHeading: seasons?.length === 0 || !seasons ? "" : options.subHeading
    }}>
      <SelectSportOptions />
    </AuthenticationLayout>
  )
}

const mapDispatchToProps = (dispatch) => ({
  getCurrentSeasons: (data) => dispatch(getCurrentSeasons(data)),
});

export default connect(null, mapDispatchToProps)(SelectSportPage);